export const translations = {
	'Compliance goal': {
		no: 'Samsvarsmål',
	},
	'Actual compliance': {
		no: 'Faktisk samsvar',
	},
	'Current downtime': {
		no: 'Nåværende nedetid',
	},
	'No downtime': {
		no: 'Ingen nedetid',
	},
	'Max allowed downtime': {
		no: 'Total tillatt nedetid',
	},
	'Create exclude period': {
		no: 'Opprett ekskludering periode',
	},
	'Are you sure you want to remove SLAs?': {
		no: 'Vil du slette SLA-ene?',
	},
	'Are you sure you want to remove SLA?': {
		no: 'Vil du slette SLA?',
	},
	'SLA successfully deleted': {
		no: 'Tjenesteavtale er slettet',
	},
	'Historic notes': {
		no: 'Historiske notater',
	},
	'Current notes': {
		no: 'Nåværende notater',
	},
	'Future notes': {
		no: 'Framtidige notater',
	},
	'SLA service history': {
		no: 'SLA tjenestehistorikk',
	},
	'SLA Configuration': {
		no: 'SLA konfigurasjon',
	},
	'Fill in the correct values in field': {
		no: 'Fyll inn alle påkrevde felter',
	},
	'Created by': {
		no: 'Opprettet av',
	},
	'Note deleted': {
		no: 'Merknad er slettet',
	},
	'Period completion': {
		no: 'Periode ferdigstillelse',
	},
	'Periods': {
		no: 'Periode',
	},
	'Select service level agreement': {
		no: 'Velg tjenesteavtale',
	},
	'Input a numeric value for periods': {
		no: 'Sett inn numerisk verdi for period',
	},
	'Maximum number of periods is ': {
		no: 'Maks antall perioder er',
	},
	'Display decimal': {
		no: 'Vis desimaler',
	},
	'Downtime before breached': {
		no: 'Nedetid før brudd',
	},
};
